import React, { Component } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import errorAnimation from "../../assets/lottie/errorAnimation.lottie";
import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import {
  backgroundLight,
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";

class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("🔥 Uncaught UI Error:", error, errorInfo);
  }

  componentDidMount() {
    // ✅ Catch ALL global errors (JS errors, API failures)
    window.onerror = (message, source, lineno, colno, error) => {
      console.error("🔥 Global Error:", {
        message,
        source,
        lineno,
        colno,
        error,
      });
      this.setState({ hasError: true, error });
    };

    // ✅ Catch ALL unhandled promise rejections
    window.addEventListener("unhandledrejection", (event) => {
      console.error("🔥 Unhandled Promise Rejection:", event.reason);
      this.setState({ hasError: true, error: event.reason });
    });
  }

  handleReset = () => {
    // ✅ Clear user session
    localStorage.removeItem("userInfo");

    // ✅ Redirect to home page
    window.location.href = "/login"; // Forces a full reload
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box w="100%" h="100vh" minH="100vh" bg="white" p="2rem">
          <Flex
            w="100%"
            h="100%"
            direction="column"
            align="center"
            justify="center"
          >
            <Box w="250px" h="250px">
              <DotLottieReact
                src={errorAnimation}
                loop
                autoplay
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
            <Heading fontSize="2.5rem" color={textPrimary}>
              Oops! Something went wrong 😕
            </Heading>
            <Text fontSize="1.5rem" color={textSecondary}>
              Please try reloading the app.
              {/* {this.state.error?.message || "Unexpected error occurred."} */}
            </Text>

            <Button
              mt="2rem"
              h="3rem"
              w="10rem"
              border={`1px solid ${newBorder}`}
              variant="solid"
              bg={backgroundLight}
              color={textSecondary}
              fontSize="md"
              size="lg"
              borderRadius="10rem"
              _hover={{
                bg: primaryAlt,
                color: white,
                cursor: "pointer",
              }}
              onClick={this.handleReset}
            >
              Reload App
            </Button>
          </Flex>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
